module.exports = __webpack_public_path__ + "static/media/LA.4c272b2a.svg";